export type NGXLoggerColorScheme = [string, string, string, string, string, string, string];

export const DEFAULT_COLOR_SCHEME: NGXLoggerColorScheme = [
  'purple',
  'teal',
  'gray',
  'gray',
  'red',
  'red',
  'red'
];
